import React, { useState, useEffect } from "react";
import {
  useParams,
  useSearchParams,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { useSelector } from "react-redux";
import { api } from "../../../config";
import MainButton from "../../components/common/mainButton";
import LogoBar from "../../components/common/logoBar";
import store from "../../redux/store";
import * as Actions from "../../redux/actions";
import NoProductWindow from "../../components/common/no-product-window";
import { useTranslation } from "react-i18next";
import CustomModal from "../../components/common/modal";
import { Modal } from "antd";
import { generatePopUpsDataByCatalog } from "../../utils";

import Loading from "../../components/common/loading";

const GetProductsByQuery = ({
  setGroupPopup,
  groupPopups,
  setOpenGroupPopup,
  openGroupPopup,
  productos,
}) => {
  const { t } = useTranslation(["data"]);

  const list =
    productos &&
    Object.keys(productos).map((key, i) => {
      return (
        <div key={i} className="blocks-container">
          <div className="blocks-title">
            <span>{key}</span>
            {groupPopups.byClave[key.toLowerCase().replace(/\s/g, "-")] && (
              <div
                onClick={() => {
                  setGroupPopup(
                    groupPopups.byClave[key.toLowerCase().replace(/\s/g, "-")]
                  ),
                    setOpenGroupPopup(!openGroupPopup);
                }}
                className="popUp"
              >
                <img src="/assets/img/informacion.png" />
              </div>
            )}
          </div>

          <div className="blocks">
            {productos[key]
              .sort((a, b) => a.rowIndex - b.rowIndex)
              .map((product, i) => {
                let imageStyle = {
                  backgroundImage: `url(${api.media.images}${product.ean})`,
                };
                return (
                  <div key={i} className="block">
                    <div className="content">
                      <div className="image" style={imageStyle} />
                      <div className="productTitle">{product.titulo}</div>
                      <div className="button">
                        <MainButton
                          link={product.ean}
                          name={t("verProductos")}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      );
    });

  return (
    <>{list && list.length > 0 ? <div className="blocks">{list}</div> : ""}</>
  );
};

const ProductsList = ({
  setGroupPopup,
  groupPopups,
  setOpenGroupPopup,
  openGroupPopup,
  products,
  isInMyCatalog,
  categoriaId,
  catalogoId,
  setFilterProducts,
  setIsInMyCatalog,
  marcaId,
}) => {
  const { t } = useTranslation(["data"]);
  const navigate = useNavigate();

  return Object.keys(products).map((key, i) => {
    const popUpsData = generatePopUpsDataByCatalog(groupPopups, catalogoId);

    return (
      <div key={i} className="blocks-container">
        <div className="blocks-title">
          <span>{key}</span>
          {popUpsData[key.toLowerCase().replace(/\s/g, "-")] && (
            <div
              onClick={() => {
                setGroupPopup(
                  popUpsData[key.toLowerCase().replace(/\s/g, "-")]
                ),
                  setOpenGroupPopup(!openGroupPopup);
              }}
              className="popUp"
            >
              <img src="/assets/img/informacion.png" />
            </div>
          )}
          <div className="delete-group-button">
            <div className="box">
              {isInMyCatalog && (
                <a
                  onClick={(e) => {
                    e.preventDefault();

                    Modal.confirm({
                      title: "Confirmar",
                      content:
                        "Estas seguro/a que quieres eliminar este grupo ?",
                      okText: "Eliminar",
                      cancelText: "Cancelar",
                      onOk: () => {
                        store
                          .dispatch(
                            Actions.deleteProducts({
                              catalogId: catalogoId,
                              categoryId: categoriaId,
                              groupId: key.toLowerCase().replace(/\s/g, "-"),
                            })
                          )
                          .then(() => {
                            store
                              .dispatch(
                                Actions.getProducts(
                                  catalogoId,
                                  categoriaId,
                                  marcaId
                                )
                              )
                              .then((data) => {
                                if (
                                  Object.keys(data.payload.data.products)
                                    .length === 0
                                ) {
                                  return navigate(`/catalogos/${catalogoId}`);
                                } else {
                                  setIsInMyCatalog(
                                    data.payload.data.isInMyCatalog
                                  );
                                  setFilterProducts(data.payload.data.products);
                                }
                              });
                          });
                      },
                    });
                  }}
                >
                  <div className="icon-descargar">
                    <img src="/assets/img/delete-icon.png" />
                  </div>
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="blocks">
          {products[key]
            .sort((a, b) => a.rowIndex - b.rowIndex)
            .map((product, i) => {
              const imgEan = product.ean.toString().replace(" ", "-");
              let imageStyle = {
                backgroundImage: `url(${api.media.images}${imgEan})`,
              };

              return (
                <div key={i} className="block">
                  <div className="content">
                    <div className="image" style={imageStyle} />
                    <div className="productTitle">{product.titulo}</div>
                    <div className="buttons">
                      <div className="button">
                        <MainButton
                          link={product.ean}
                          name={t("verProductos")}
                        />
                      </div>
                      {isInMyCatalog && (
                        <div className="delete-products-button">
                          <div className="box">
                            <a
                              onClick={(e) => {
                                e.preventDefault();

                                Modal.confirm({
                                  title: "Confirmar",
                                  content:
                                    "Estas seguro/a que quieres eliminar este producto ?",
                                  okText: "Eliminar",
                                  cancelText: "Cancelar",
                                  onOk: () => {
                                    store
                                      .dispatch(
                                        Actions.deleteProducts({
                                          catalogId: catalogoId,
                                          categoryId: categoriaId,
                                          groupId: key
                                            .toLowerCase()
                                            .replace(/\s/g, "-"),
                                          ean: product.ean,
                                        })
                                      )
                                      .then(() => {
                                        store
                                          .dispatch(
                                            Actions.getProducts(
                                              catalogoId,
                                              categoriaId,
                                              marcaId
                                            )
                                          )
                                          .then((data) => {
                                            setIsInMyCatalog(
                                              data.payload.data.isInMyCatalog
                                            );
                                            setFilterProducts(
                                              data.payload.data.products
                                            );
                                          });
                                      });
                                  },
                                });
                              }}
                            >
                              <div className="icon-descargar">
                                <img src="/assets/img/delete-icon.png" />
                              </div>
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  });
};

const Products = () => {
  const [filterProducts, setFilterProducts] = useState(null);

  const [productsFind, setProductsFind] = useState(null);

  const [isInMyCatalog, setIsInMyCatalog] = useState(null);

  const [openPopup, setOpenPopup] = useState(null);

  const [openGroupPopup, setOpenGroupPopup] = useState(null);

  const [groupPopup, setGroupPopup] = useState(null);

  const { popupData } = useSelector((state) => state.catalog);

  const [popup, setPopup] = useState();

  let { marcaId, catalogoId, categoriaId } = useParams();

  const location = useLocation();

  const getRoute = location.pathname.split("/").filter((el) => el);

  const [searchParams, setSearchParams] = useSearchParams(location.search);

  const query = searchParams.get("key");

  // useEffect(() => {
  //   store
  //     .dispatch(Actions.getProducts(catalogoId, categoriaId, marcaId))
  //     .then((data) => {
  //       setIsInMyCatalog(data.payload.data.isInMyCatalog);
  //       setFilterProducts(data.payload.data.products);
  //     });
  // }, []);

  useEffect(() => {
    store
      .dispatch(Actions.getProducts(catalogoId, categoriaId, marcaId))
      .then((data) => {
        setIsInMyCatalog(data.payload.data.isInMyCatalog);
        setFilterProducts(data.payload.data.products);
      });
  }, [marcaId]);

  // useEffect(() => {
  //   if (getRoute[0] === "marcas") {
  //     store.dispatch(Actions.findBrandPopup({ marcaId }));
  //   }
  // }, [getRoute[1]]);

  useEffect(() => {
    if (query || query === "") {
      store
        .dispatch(Actions.searchProducts({ key: query, catalogoId: "*" }))
        .then((data) => {
          const products = data.payload.data.reduce((list, item) => {
            if (!list[item.nombreGrupo]) {
              list[item.nombreGrupo] = [];
            }
            list[item.nombreGrupo].push(item);
            return list;
          }, {});

          setProductsFind(products);
        });
    }
  }, [query]);

  useEffect(() => {
    setPopup(popupData);
  }, []);

  return (
    <>
      {!filterProducts && <Loading />}
      {filterProducts && (
        <div
          className="products-container"
          style={
            (query && productsFind && productsFind.length === 0) || query === ""
              ? {
                  backgroundColor: "#F5F5F5",
                  width: "100%",
                  minHeight: "660px",
                  margin: "0px",
                }
              : {}
          }
        >
          {((query !== "" && productsFind && productsFind.length !== 0) ||
            marcaId) && (
            <LogoBar
              marcaId={marcaId}
              setOpenPopup={setOpenPopup}
              openPopup={openPopup}
              popup={JSON.parse(JSON.stringify(popup))}
              setPopup={setPopup}
            />
          )}

          {openPopup && (
            <CustomModal
              popup={popup}
              setPopup={setPopup}
              setOpenPopup={setOpenPopup}
              openPopup={openPopup}
            />
          )}

          {openGroupPopup && (
            <CustomModal
              popup={groupPopup}
              setPopup={setPopup}
              setOpenPopup={setOpenGroupPopup}
              openPopup={openGroupPopup}
            />
          )}

          {((filterProducts && !productsFind) ||
            (filterProducts && marcaId)) && (
            <div className="content">
              {filterProducts && (
                <ProductsList
                  setGroupPopup={setGroupPopup}
                  groupPopups={JSON.parse(JSON.stringify(popupData))}
                  setOpenGroupPopup={setOpenGroupPopup}
                  openGroupPopup={openGroupPopup}
                  products={filterProducts}
                  isInMyCatalog={isInMyCatalog}
                  categoriaId={categoriaId}
                  catalogoId={catalogoId}
                  setFilterProducts={setFilterProducts}
                  setIsInMyCatalog={setIsInMyCatalog}
                  marcaId={marcaId}
                />
              )}
            </div>
          )}

          {query && (
            <div className="content">
              <GetProductsByQuery
                setGroupPopup={setGroupPopup}
                groupPopups={popup}
                setOpenGroupPopup={setOpenGroupPopup}
                openGroupPopup={openGroupPopup}
                productos={productsFind}
              />
            </div>
          )}
          {((query && productsFind && productsFind.length === 0) ||
            query === "") && <NoProductWindow />}
        </div>
      )}
    </>
  );
};

export default Products;
